import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useHistory, useLocation } from 'react-router-dom';

import { Helmet } from 'react-helmet';

const SettingsPage = () => {
    const { t } = useTranslation();
    const history = useHistory();
    const location = useLocation();

    useEffect(() => {
        document.body.style.overflow = 'hidden';
        return () => { document.body.style.overflow = 'unset'; };
    }, []);

    const handleClose = () => {
        if (location.state && location.state.background) {
            history.goBack();
        } else {
            history.push('/');
        }
    };

    return (
        <div className="settings-overlay" onClick={handleClose}>

            <Helmet>
                {/* Настройки – Физика */}
                <title>{`${t('translate.app_name2')}: ${t('translate.setting_name')}`}</title>
            </Helmet>

            <div className="settings-modal" onClick={(e) => e.stopPropagation()}>

                <button className="settings-modal__close" onClick={handleClose}>×</button>

                <div className="settings-modal__content">

                    <h2 className="settings-modal__title">
                        {t('translate.setting_name')}
                    </h2>

                    <div className="settings-list">

                        {/* ============================== ОСНОВНЫЕ ============================== */}
                        <div className="settings-header settings-header--base">
                            <div className="settings-header__target"></div>
                            <h3 className="settings-header__title">{t('translate.setting_base_title')}</h3>
                        </div>

                        <Link to='/settings/language' className="settings-item settings-item--lang">
                            <div className="settings-item__icon"></div>
                            <div className="settings-item__text">
                                <h4 className="settings-item__title">{t('translate.setting_language1')}</h4>
                                <p className="settings-item__desc">{t('translate.setting_language1')}</p>
                            </div>
                        </Link>

                        {/* ============================== ДОПОЛНИТЕЛЬНО ============================== */}
                        <div className="settings-header settings-header--extra">
                            <div className="settings-header__target"></div>
                            <h3 className="settings-header__title">{t('translate.setting_more_title')}</h3>
                        </div>

                        <a href='mailto:nks199731@gmail.com' className="settings-item settings-item--bug" target='_blank' rel='noreferrer'>
                            <div className="settings-item__icon"></div>
                            <div className="settings-item__text">
                                <h4 className="settings-item__title">{t('translate.setting_error1')}</h4>
                                <p className="settings-item__desc">{t('translate.setting_error2')}</p>
                            </div>
                        </a>

                        <a href='https://play.google.com/store/apps/details?id=august.fizika' className="settings-item settings-item--android" target='_blank' rel='noreferrer'>
                            <div className="settings-item__icon"></div>
                            <div className="settings-item__text">
                                <h4 className="settings-item__title">Application for Android</h4>
                                <p className="settings-item__desc">{t('translate.setting_update2')}</p>
                            </div>
                        </a>

                        <a href='http://itunes.apple.com/app/id1451726577' className="settings-item settings-item--apple" target='_blank' rel='noreferrer'>
                            <div className="settings-item__icon"></div>
                            <div className="settings-item__text">
                                <h4 className="settings-item__title">Application for iOS</h4>
                                <p className="settings-item__desc">{t('translate.setting_update2')}</p>
                            </div>
                        </a>

                        {/* ============================== ВЕРСИЯ ============================== */}
                        <div className="settings-header settings-header--version">
                            <div className="settings-header__target"></div>
                            <h3 className="settings-header__title">{t('translate.setting_version_title')}</h3>
                        </div>

                        <div className="settings-item settings-item--no-hover settings-item--info">
                            <div className="settings-item__icon"></div>
                            <div className="settings-item__text">
                                <h4 className="settings-item__title">{t('translate.setting_version1')}</h4>
                                <p className="settings-item__desc">1.0.0</p>
                            </div>
                        </div>

                        {/* ============================== КОПИРАЙТ ============================== */}
                        <div className="settings-footer">
                            <p>© <a href='https://chernykh.tech/' target='_blank' rel='noreferrer'>chernykh.tech</a> / All rights reserved, {new Date().getFullYear()}</p>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default SettingsPage;